// Copyright 2016 Activision Publishing, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining
// a copy of this software and associated documentation files (the "Software"),
// to deal in the Software without restriction, including without limitation
// the rights to use, copy, modify, merge, publish, distribute, sublicense,
// and/or sell copies of the Software, and to permit persons to whom the Software
// is furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
export const FAST_FILTER_COEFFICIENTS = [
    {
        frameX: [
            [0.0002037563, 0.0045063655, -0.0016408688, 0.00012037493],
            [-9.1834951e-5, -0.008947532, -8.1524405e-5, -3.9080094e-5],
            [-2.6038267e-5, -6.8409667e-5, 7.2175702e-5, 0.25492775],
            [-9.9426044e-5, 0.0025427756, -0.00074437925, 1.1773191e-5],
            [-3.2668211e-5, 0.0026930659, -4.824934e-5, -0.0006835048],
            [-0.0002864144, -0.0032220854, 0.0021558286, -0.00014573736],
        ],
        frameY: [
            [0.00030683201, 0.0026819548, -0.00060011756, -0.0067169226],
            [-0.0030993251, 0.0098575575, 0.0022416671, -8.9075401e-5],
            [0.00052405626, 0.00057860515, 0.00011654518, -0.048018609],
            [0.00010850967, -0.0088443512, -0.0018168095, 8.6633128e-5],
            [0.003333989, -0.0050956447, -8.0414612e-5, 0.0049721239],
            [-4.0961436e-5, -8.5486984e-5, 0.0058683066, 2.2978359e-5],
        ],
        frameZ: [
            [0.99999993, 0.99998625, 0.99999847, 0.99997743],
            [0.99999519, 0.99991138, 0.99999748, 1.0],
            [0.99999986, 0.99999983, 0.99999999, 0.96576708],
            [0.99999999, 0.99995765, 0.99999807, 1.0],
            [0.99999444, 0.99998339, 1.0, 0.99998741],
            [0.99999996, 0.99999481, 0.99998046, 0.99999999],
        ],
        lod: [
            [-0.32267524, -0.65409377, -1.4666488, 0.87153305],
            [-1.264365, 0.89880861, -1.2245906, -0.88501403],
            [-0.31118682, -0.086150323, -0.58811532, 1.1317711],
            [-1.2193493, 1.250379, -1.0871569, -0.12694096],
            [-0.4012249, -0.47436307, -0.59661001, 2.7313005],
            [-1.3109856, 0.60929855, 0.55672643, -0.39880018],
        ],
        weight: [
            [0.93273157, 0.59530745, 1.1994788, 0.19102276],
            [1.2272239, 0.23245736, 1.2577607, 2.5491008],
            [1.1210098, 0.83074953, 1.3049282, -0.001940633],
            [1.5839111, 0.10520816, 1.150458, 2.3251789],
            [0.688692, 0.59807498, 1.3374877, 0.095746692],
            [1.3054173, 0.36604721, 0.065870226, 1.6496907],
        ],
    },
    {
        frameX: [
            [0.10348445, -4.6771514e-7, -0.011513131, 8.8921052e-5],
            [-0.042152043, 0.013143535, 0.00029120107, 0.036661611],
            [-0.04516036, 0.011438473, -0.0099289792, -0.011707897],
            [-0.034779497, 0.0090981166, -5.4202726e-5, 0.038592793],
            [-0.0071967376, -0.0056614418, -0.012278945, 0.0056867462],
            [-0.037678514, 0.011570177, 0.00029044557, 0.038583909],
        ],
        frameY: [
            [0.048320869, 1.4603673e-5, 0.0092672368, 0.00033289199],
            [0.0071001761, -0.0090106091, -0.0027305905, -0.00221479],
            [-0.0027204116, 0.00017921587, 0.015296357, -0.00010306185],
            [0.0079350203, -0.014772431, -1.2410913e-5, -0.0062296897],
            [0.025087691, 0.00086046427, 0.015034685, -0.00078224706],
            [0.00074587265, -0.014602074, 0.00027338224, -0.012848552],
        ],
        frameZ: [
            [0.99345662, 1.0, 0.99989078, 0.99999994],
            [0.99908598, 0.99987302, 0.99999623, 0.99932528],
            [0.99897605, 0.99993456, 0.9998337, 0.99993145],
            [0.99936351, 0.99984949, 1.0, 0.9992356],
            [0.99965935, 0.9999836, 0.99981158, 0.99998352],
            [0.99928963, 0.99982644, 0.99999992, 0.99917276],
        ],
        lod: [
            [3.6882765, 0.15963861, 0.55983965, 0.4075649],
            [2.1169304, 0.56463157, 0.52957047, 2.0117964],
            [3.1080461, 0.09682931, 0.42125986, 0.089254784],
            [1.4247315, 0.48411378, -0.17039102, 1.7431674],
            [4.0339531, 0.14046159, 0.89848909, 0.011661811],
            [1.9787852, 0.61750145, 0.63514194, 1.9359003],
        ],
        weight: [
            [0.030848793, 1.4472743, 1.4356825, 1.4078009],
            [0.37639678, 1.0793106, 1.1945413, 0.43983395],
            [0.27451605, 1.5256415, 1.016769, 1.4850575],
            [0.54580883, 1.1332879, 3.1331784, 0.60772955],
            [0.11785158, 1.3928946, 0.94998805, 1.0377182],
            [0.2842108, 1.0026911, 1.9064553, 0.27147854],
        ],
    },
    {
        frameX: [
            [-0.096789259, 0.10326967, 0.0011799959, -0.03077328],
            [0.08342021, 0.033260738, -0.00045864451, -0.021450568],
            [-0.093369441, -0.05807574, -0.033745214, 0.023817208],
            [0.056747754, 0.031140512, 0.00019362509, -0.023727797],
            [-0.084538386, -0.040545412, -0.0076838784, 0.03424599],
            [0.074312056, 0.027619787, 0.0015509082, -0.031043528],
        ],
        frameY: [
            [-0.0085160473, -0.012179292, 0.0049910118, 0.020224799],
            [0.022559343, -0.016273333, -0.0069382139, 0.00058083224],
            [-0.001115062, 0.035002846, -0.0038974773, -0.039378629],
            [0.0014921617, -0.00058523872, -0.0011606685, 0.02807528],
            [-0.021454809, 0.052957852, -0.0022083677, -0.027956663],
            [-0.016486487, -0.0040233682, 0.00029949558, 0.021924605],
        ],
        frameZ: [
            [0.99526846, 0.99457883, 0.99998685, 0.99932175],
            [0.99625908, 0.99931422, 0.99997583, 0.99976974],
            [0.99563091, 0.99769836, 0.99942287, 0.99894047],
            [0.99838743, 0.99951485, 0.99999931, 0.99932416],
            [0.99618922, 0.99777329, 0.99996804, 0.99902234],
            [0.99709875, 0.9996104, 0.99999875, 0.99927754],
        ],
        lod: [
            [3.0342011, 4.8022834, 1.3814123, 1.5280754],
            [2.9043837, 1.7325954, 1.422223, 2.0569263],
            [3.0358722, 5.3331504, 1.5680146, 1.6079289],
            [3.2062833, 1.5368069, 1.0484709, 1.5399477],
            [2.4471653, 4.0916696, 1.5060688, 1.5807009],
            [2.6932695, 1.5161537, 1.3991175, 1.6301918],
        ],
        weight: [
            [0.50787578, 0.17735471, 1.4006765, 1.0878482],
            [0.69514518, 1.6765187, 1.2224869, 1.3461327],
            [0.71381288, 0.17509216, 1.2712934, 0.94575821],
            [1.1817337, 1.796984, 1.8671538, 1.5708691],
            [0.55621228, 0.38291359, 1.4128781, 0.82625349],
            [0.72441647, 1.005794, 1.5522327, 1.6032524],
        ],
    },
    {
        frameX: [
            [-0.00041301094, -0.095882618, 0.26932618, -0.25137214],
            [0.13737415, -0.12694293, -0.0090389663, 0.07227623],
            [-0.005236407, -0.0072961249, 0.27776083, -0.19536433],
            [0.12781899, -0.042881667, -0.095979169, 0.088937396],
            [0.037496084, -0.090547583, 0.22112334, -0.21930294],
            [0.13353408, -0.084346121, -0.011365728, 0.043459312],
        ],
        frameY: [
            [-0.05799135, -0.048612281, 0.02422989, 0.015536268],
            [-0.083144241, 0.039381032, 0.018705957, 0.029297922],
            [0.026364989, -0.041927591, 0.036718516, 0.0050376168],
            [-0.11562256, 0.043521976, -0.014481644, 0.01529188],
            [-0.047859898, -0.057779647, -0.053171395, -0.0063193506],
            [-0.028781196, 0.041145059, -0.00018523142, 0.053524246],
        ],
        frameZ: [
            [0.998317, 0.99420489, 0.96274416, 0.96776581],
            [0.98702349, 0.99112796, 0.99978417, 0.99695425],
            [0.99963867, 0.99909401, 0.95994827, 0.9807178],
            [0.98503489, 0.99813175, 0.99527799, 0.99591983],
            [0.99815003, 0.99421459, 0.97379529, 0.97563635],
            [0.99062621, 0.99558667, 0.99993539, 0.99762039],
        ],
        lod: [
            [2.3221943, 2.5383575, 4.3177232, 4.2016467],
            [3.1936529, 3.0443024, 2.548962, 2.7636456],
            [2.5923827, 2.3497949, 4.2471014, 4.1975975],
            [3.3748785, 3.2836577, 2.9220414, 2.7175317],
            [2.3290083, 2.5560991, 4.3572168, 4.4372585],
            [3.1512055, 3.2863613, 2.4475378, 2.3620003],
        ],
        weight: [
            [0.62833231, 0.52378061, 0.55845033, 0.64883444],
            [0.76905594, 1.1017801, 1.8714048, 1.5664383],
            [1.5283278, 1.2423369, 0.62247385, 1.0341956],
            [0.77484548, 1.6866409, 1.0307399, 1.4224643],
            [0.85627405, 0.72516079, 0.70094339, 0.7547877],
            [1.202842, 1.7650605, 1.5938526, 0.97031337],
        ],
    },
    {
        frameX: [
            [-0.078108035, -0.049518839, 0.26950139, -0.51522828],
            [0.43015518, -0.045354216, 0.094550359, -0.2395012],
            [-0.079900522, -0.082582235, 0.24464909, -0.5234896],
            [0.38422945, -0.023833644, 0.07334288, -0.22827313],
            [-0.075370379, -0.05156594, 0.19883182, -0.45064193],
            [0.46285395, 0.021899343, 0.10155287, -0.25974773],
        ],
        frameY: [
            [0.068681419, -0.32175988, 0.15143274, -0.0066205388],
            [-0.17060226, 0.31051319, -0.080511981, -0.1593209],
            [0.08167251, -0.32517768, 0.10937023, -0.06941926],
            [-0.14580685, 0.32474959, -0.081718057, -0.11068378],
            [0.053961394, -0.29322836, 0.10408839, -0.02243046],
            [-0.030598471, 0.34332821, -0.091528353, -0.16299796],
        ],
        frameZ: [
            [0.99457629, 0.9455255, 0.95101899, 0.85702741],
            [0.88648824, 0.94948647, 0.99225906, 0.95773484],
            [0.99345131, 0.94204015, 0.96342357, 0.84919939],
            [0.9116513, 0.94549969, 0.99395321, 0.96728511],
            [0.99569447, 0.95465076, 0.97449039, 0.89242295],
            [0.88590629, 0.93896015, 0.99061071, 0.95182077],
        ],
        lod: [
            [3.6380949, 4.1749529, 4.1351439, 4.8389883],
            [5.256362, 4.2027959, 3.6096892, 3.9848645],
            [3.5689427, 3.8620869, 4.0023981, 4.8268584],
            [5.1128497, 4.468934, 3.5851596, 4.047485],
            [3.7014988, 4.1310058, 4.2446872, 5.3049323],
            [4.8659881, 4.3133002, 3.4582876, 3.8863853],
        ],
        weight: [
            [1.6276316, 0.7747672, 1.0485958, 0.73900224],
            [0.72010795, 0.65403093, 1.3179681, 0.65610074],
            [1.5881174, 0.55108527, 1.0509725, 0.72153362],
            [1.1389053, 1.0905142, 1.6661598, 0.9987548],
            [1.977914, 0.83001686, 1.0571479, 0.80249183],
            [0.94107069, 0.80840873, 0.95379751, 0.50386367],
        ],
    },
    {
        frameX: [
            [0.015525428, -0.48038019, -0.021799698, 0.43629156],
            [0.045681247, -0.55039024, -0.54573329, 0.57817853],
            [-0.045869129, -0.42209953, -0.14040829, 0.37787106],
            [0.66327604, -0.70070311, -0.55261635, 0.63446196],
            [0.015397585, -0.43515767, -0.021927897, 0.4203714],
            [0.85681772, -0.65394729, -0.67557236, 0.60104142],
        ],
        frameY: [
            [-0.31503888, -0.26745648, 0.26817896, 0.26548747],
            [-0.93282124, -0.033621213, 0.68374802, -0.10858524],
            [-0.21723689, -0.17935495, 0.38521982, 0.2578335],
            [-0.39913153, 0.23555359, 0.59589456, -0.19075103],
            [-0.28851798, -0.24142459, 0.28279261, 0.24766617],
            [-0.29435977, -0.25850549, 0.57790878, -0.200546],
        ],
        frameZ: [
            [0.94895177, 0.83528552, 0.96312243, 0.85974768],
            [0.35743218, 0.8342303, 0.48442112, 0.80865248],
            [0.97504059, 0.88863029, 0.9120807, 0.88923301],
            [0.63305523, 0.67344611, 0.58268761, 0.74904744],
            [0.95735066, 0.86738225, 0.9589304, 0.87289711],
            [0.42333878, 0.71100482, 0.45784651, 0.77364753],
        ],
        lod: [
            [5.3641275, 5.2550422, 5.3103777, 5.2851215],
            [5.2657045, 6.2095784, 6.9549598, 4.9205516],
            [5.163385, 5.3141038, 4.9907618, 5.3583852],
            [6.1257061, 6.1102338, 6.9549598, 5.3129951],
            [5.3138838, 5.3257842, 5.3133783, 5.2687156],
            [5.8915091, 6.153324, 6.9549598, 4.9568971],
        ],
        weight: [
            [3.1221918, 1.1882615, 2.6991784, 1.1185048],
            [-0.2322432, -0.16590163, 0.088416958, 0.057399579],
            [3.4395383, 1.5836276, 2.6242352, 1.2873336],
            [-0.23767634, -0.79425452, 0.20477899, 0.40461516],
            [2.2521751, 1.1933374, 2.3309484, 1.0185309],
            [-0.099258385, -0.2173726, 0.0736866, 0.15470436],
        ],
    },
];
//# sourceMappingURL=skyFastFilterCoefficients.js.map